/**
 * Schermteksten in het Engels.
 *
 * GEMAAKT DOOR EEN MACHINE uit teksten/nl.ts, met
 * server/scripts/vertaal-teksten.ts. Niet met de hand bijwerken: een
 * volgende ronde overschrijft het.
 *
 * Machinevertaling van een interface is een START. Knoppen zijn kort en
 * zonder context, en juist daar gaat het mis. Laat dit nakijken door
 * iemand die de taal spreekt voordat het naar echte gebruikers gaat.
 */
import type { Teksten } from './nl';

export const en: Teksten = {
  kamerOphalen: "Retrieving room…",
  kamerWerktNiet: "This room is not working",
  serverReageertNiet: "The server is not responding",
  probeerOpnieuw: "Try again",
  vraagNieuweCode: "Ask the person who shared the code for a new one. A room expires after a few hours.",
  welkeTaalSprekJij: "Which language do you speak?",
  jouwStem: "Your voice in the translation",
  man: "Male",
  vrouw: "Female",
  pincode: "PIN code",
  pincodeUitleg: "You will get this from the person who shared the code.",
  gaDeKamerIn: "Enter the room",
  kiesEerstJeTaal: "Choose your language first",
  microfoonAanvragen: "Requesting microphone…",
  toestemmingUitleg: "Your browser will ask for microphone permission. Without it, you can only type.",
  microfoonTestLink: "Test your microphone first",
  stemGaatMee: "In this room, the other person also hears your own voice, alongside the translation.",
  alleenChatMelding: "This conversation is chat only. You type your messages and read the translation; nothing is read aloud.",
  verlooptOm: "Expires at",
  nooitVasteKamer: "Never, permanent room",
  kamer: "Room",
  tolkgesprek: "Interpreted conversation",
  juisteKamer: "You are at the right room. In a moment you will be able to join the conversation here.",
  jij: "you",
  deAnder: "the other",
  verbinden: "Connecting…",
  verbonden: "Connected",
  verbindingKwijt: "Connection lost. Retrying…",
  wachtenOpAnder: "You're in. Waiting for the other person to scan the QR code.",
  allebeiInDeKamer: "You are both in the room.",
  anderIsWeg: "The other person is gone",
  anderSpreekt: "The other person is speaking…",
  jeKuntErNietIn: "You cannot enter",
  overgenomenTitel: "Continued on another device",
  overgenomenUitleg: "This conversation was just opened on another device. You can continue there.",
  terug: "Back",
  geluidStaatUit: "The sound is muted. Tap anywhere on the screen.",
  tikHier: "tap here",
  bewaardTot: 'Kept until {tijd}',
  bewaardVast: "Permanent room. Messages are kept for 30 days.",
  spreekIn: "Speak",
  luisteren: "Listening… tap to stop",
  uitschrijven: "Transcribing…",
  tijdOmTeVerbeteren: "Time to improve",
  altijdZelfVersturen: "Always review and send yourself",
  jijVerstuurtZelf: "You send it yourself",
  uit: "off",
  sec: "sec",
  vertalingMeteenAfspelen: "Play translation immediately",
  typHierJeBericht: "Type your message here…",
  stuur: "Send",
  geenOpnameMogelijk: "This browser cannot record audio. Typing still works.",
  verstaanAls: "Understood as",
  tellerStaatStil: "timer is paused",
  versturen: "Send",
  wis: "Clear",
  jijZei: "you said",
  vertaald: "translated",
  duimOmhoog: "This is correct",
  duimOmlaag: "This is incorrect",
  opnieuwProberenKnop: "Try again with a better model",
  opnieuwProberenBezig: "Translating again…",
  duimTranscriptWoordenlijstUitnodiging: "Misunderstood? Correct it in the glossary:",
  instellingenAanpassen: "Adjust settings",
  geldtVoorJullieBeiden: "Applies to both of you",
  alleenVoorJou: "Only for you",
  stuurMijnStemMee: "Send my own voice",
  verbeterSpelfouten: "Correct spelling errors in my text",
  verbeterSpelfoutenUit: "Turning this off shows exactly what was understood, mistakes and all.",
  alleenChat: "Chat only: no speech, no microphone",
  alleenChatUitleg: "You both type. The translation and the original text are shown; nothing is read aloud.",
  aangepastDoorDeAnder: "The other person adjusted the settings.",
  foutSpraak: "The translation is there, but no voice came out.",
  foutSpraakQuota: "The speech quota for today is used up. The text still works; voice will return tomorrow.",
  foutBudgetKamer: "This conversation has reached its limit, so translation is paused. The person who created it can raise the limit; then it works again right away.",
  foutBudgetMaand: "The app's monthly budget is used up. Translation will work again once the administrator adjusts it.",
  foutTaal: "That language is not possible: you would both be speaking the same language.",
  origineel: "original",
  vertalen: "Translating…",
  vertalenMislukt: "Translation failed.",
  opnieuwAfspelen: "Play translation again",
  hoorDeAnder: "Listen to how the other person said it themselves",
  woordenlijst: "Safety net glossary",
  woordenlijstUitleg: "Does the app structurally misunderstand a name or technical term? Define what is meant here.",
  hijHoort: "it hears…",
  jijBedoelt: "you mean…",
  ookVolgendeGesprekken: "Also in future conversations — otherwise it only applies here",
  voegToe: "Add",
  bezig: "Busy…",
  lijstNietGeladen: "The list could not be loaded.",
  toevoegenMislukt: "Adding failed.",
  verwijderenMislukt: "Deleting failed.",
  overal: "everywhere",
  verwijder: "Delete",
  overDitGesprek: "About this conversation",
  toon: "Tone of the translation",
  sfeer: "Atmosphere of the conversation",
  jouwPlek: "Your location",
  hoeHetWerkt: "The server transcribes your recording and translates it in one go. Your own voice is sent to the other person.",
  kleinereTekst: "Smaller text",
  grotereTekst: "Larger text",
  insprekenVerbergen: "Hide speaking",
  insprekenTonen: "Show speaking",
  toetsenbordVerbergen: "Hide keyboard",
  toetsenbordTonen: "Show keyboard",
  vormAutomatisch: "Automatic",
  vormInformeel: "Informal",
  vormFormeel: "Formal",
  sfeerNeutraal: "Neutral",
  sfeerZakelijk: "Professional",
  sfeerOfficieel: "Official",
  sfeerVriendschappelijk: "Friendly",
  sfeerPartner: "Partner",
  foutKamerVol: "This room is full. Only two people can enter.",
  plekBezetTitel: "Your place is taken",
  plekBezetUitleg: "Someone is already on your side of this conversation, in your language. Usually that is you: the conversation is still open on another device or in another tab. Close it there and try again. It can take a minute and a half before the place is free.",
  plekBezetWissel: "Is it you? Type WISSEL to move the conversation to this device. The other device will then close.",
  plekBezetKnop: "Move to this device",
  foutKamerVerlopen: "This room has expired or is closed.",
  foutKamerOnbekend: "This room does not exist.",
  foutPinNodig: "This room requires a PIN code.",
  foutPinFout: "That PIN code is incorrect.",
  foutProtocol: "The app and the server do not understand each other. Refresh the page.",
  foutMicroGeweigerd: "You denied microphone access. Click the padlock icon in the address bar and enable it there.",
  foutGeenMicro: "No microphone found. Connect one and try again.",
  foutMicroInGebruik: "The microphone is being used by another program. Close it and try again.",
  foutGeenHttps: "The microphone only works on a secure connection. Open this page via https.",
  foutMicroOnbekend: "The microphone could not be started.",
  foutNietsOpgenomen: "Nothing was recorded. Is your microphone turned on?",
  foutNietsGehoord: "Nothing heard. Is your microphone turned on and are you speaking loudly enough?",
  foutOpnameTeLang: "That recording is too long. Speak in shorter segments.",
  foutMicroGedempt: "Your microphone is muted. Unmute it and try again.",

  // --- microfoontest ---
  micTitel: "Microphone test",
  micOnderschrift: "Four tests in a row, five seconds each. Keep talking throughout.",
  micStart: "Start the test",
  micTest1: "1. Recognition only",
  micTest2: "2. Recording only",
  micTest3: "3. Together — recording first",
  micTest4: "4. Together — recognition first",
  micFase1: "1 of 4: recognition only — say a short sentence",
  micFase2: "2 of 4: recording only — keep talking",
  micFase3: "3 of 4: recording first, then recognition — keep talking",
  micFase4: "4 of 4: recognition first, then recording — keep talking",
  micKlaar: "done",
  micGehoord: "heard",
  micOpnameformaat: "Recording format",
  micGeen: "none",
  micBeveiligd: "Secure connection",
  micJa: "yes",
  micNee: "NO",
  micBrowser: "Browser",
  micGeenHttps: "Without https the browser will not release the microphone. On localhost it is allowed.",
  micGeenHerkenning: "This browser has no speech recognition.",
  micZegIets: "say something…",
  micWoordenBinnen: "words are coming in",
  micKonNietStarten: "could not start",
  micGeenRecorder: "This browser does not know MediaRecorder.",
  micOpnemen: "recording…",
  micNietsOpgenomen: "nothing recorded",
  micGeenMicrofoon: "no microphone",
  micOpnameEerst: "recording first…",
  micHerkenningEerst: "recognition first…",
  micOpnameStarttNiet: "recording did not start",
  micSamenGelukt: "Together. Recording {kb} kB.",
  micAlleenOpname: "Recording yes, recognition no.",
  micAlleenHerkenning: "Recognition yes, recording no.",
  micGeenVanBeide: "Neither.",
  micNetwerkFout: "Speech recognition could not reach the server.",
  micAfgebroken: "The recording was aborted.",
  verslagTitel: "Conversation record",
  verslagWie: "Who",
  verslagOrigineel: "Original",
  verslagVertaling: "Translation",
  verslagSpreker: "Speaker {x}",
  verslagBerichten: "Messages",
  verslagGemaaktOp: "Created",
  verslagGeenOpname: "Not a verbatim recording.",
  verslagNootOrigineel: "“Original” is the text as the app understood the speaker.",
  verslagNootCorrectie: "Spelling correction was on: small typing errors have been corrected.",
  verslagNootAangepast: "Whoever spoke could still edit the text before sending.",
  verslagGesproken: "spoken",
  verslagGetypt: "typed",
  verslagMislukt: "Translation failed. The other person did not see this sentence in their own language.",
  verslagNietKlaar: "The translation was not ready yet when this record was made.",
  verslagVertrouwelijk: "Confidential.",
  verslagAlleenDeelnemers: "This record contains the content of a private conversation and is intended only for the participants.",
  verslagGewist: "The conversation will be deleted from {tijd}. After that, this record cannot be made again.",
  verslagGewistVast: "Permanent room: each message is deleted 30 days after it was sent. Older messages are not in this record.",
};
